export const cart = {
  get: 'orderEndpoint/v2/priceDeliveryOrder',
  getAgile: 'orderEndpoint/priceDeliveryOrderAgile',
  addProduct: 'orderEndpoint/addDeliveryOrderItem',
  deleteProduct: 'orderEndpoint/deleteDeliveryOrderItem',
  deleteCart: 'orderEndpoint/deleteDeliveryOrder',
  getAdvertisedItems: 'algoliaEndpoint/getAdvisedItem',
  getHighDemand: 'algoliaEndpoint/getCartDeliveryLabelConfigByStoreId',
  getHighDemandVzla: 'algoliaEndpoint/getCartDeliveryLabelConfigByStoreIdWithOutRestrictions',
  getSubstitutes: 'orderEndpoint/getOptimalRouteInCheckout',
  getSubstitutesV2: 'orderEndpoint/v2/getOptimalRouteInCheckout',
  handleSubstitutes: 'orderEndpoint/handleDeliveryOrderItems',
  merge: 'customerEndpoint/mergeShoppingCartAnonymous',
  shoppingCart: 'shopping-cart/v1/',
  topsort: 'https://api.topsort.com/v2/events',
  getScheduleConfig: 'catalog/r/CO/v1/locations/:storeId/schedule',
};
